import React from "react";
import Layout from "../components/layout";
import { useStaticQuery, graphql } from "gatsby";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../styles/styles.css";

const Organization = ({ className, name }) => {
  return <div class={className}>{name}</div>;
};

const Degree = ({ className, name }) => {
  return <div class={className}>{name}</div>;
};

const Completion = ({ className, date }) => {
  return <div>{date}</div>;
};

const GPA = ({ className, gpa }) => {
  return <div className="float-md-right"> GPA: {gpa._4_point}</div>;
};

const WorkList = ({ title, work }) => {
  return (
    <>
      <div>{title + ":"}</div>
      <ul>
        {work.map((course, key) => (
          <li key={key}>{course}</li>
        ))}
      </ul>
    </>
  );
};

const Education = ({ education }) => {
  return (
    <Card className={styles.card}>
      <Card.Header className={styles.cardHeader}>
        <Col>
          <Row>
            <Col md={8} xs={12}>
              <Organization
                className="education-name"
                name={education.organization}
              />
              <Degree className="education-title" name={education.degree} />
            </Col>
            <Col md={4} xs={12}>
              <div className="float-md-right">
                <Completion date={education.completion} />
                <GPA gpa={education.gpa} />
              </div>
            </Col>
          </Row>
        </Col>
      </Card.Header>
      <Card.Body>
        <WorkList title="Course Work" work={education.courseWork} />
        <WorkList title="Projects" work={education.projects} />
      </Card.Body>
    </Card>
  );
};

const EducationPage = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        education {
          items {
            organization
            degree
            gpa {
              _4_point
              _10_point
            }
            completion
            courseWork
            projects
          }
        }
      }
    }
  `).dataYaml.education.items;

  const educationItems = data.map(education => (
    <Education education={education} />
  ));

  return <Layout title="Education">{educationItems}</Layout>;
};

export default EducationPage;
